import { useState, useEffect } from "react";
import { getIndentInvoiceNoList } from "../services/productionService";

const useIndentInvoiceNoList = () => {
    const [invoiceNoList, setInvoiceNoList] = useState([]);
    const [isInvoiceNoListLoaded, setIsInvoiceNoListLoaded] = useState(false);
    const [selectedInvoiceNo, setSelectedInvoiceNo] = useState(null);
    const [selectedInvoiceNoID, setSelectedInvoiceNoID] = useState(null);

    const fetchInvoiceNoList = async (selectedIndentNo = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_indent_no: selectedIndentNo
        };

        try {
            const data = await getIndentInvoiceNoList(para);
            if (data && data.length > 0) {
                setInvoiceNoList(data);
                setIsInvoiceNoListLoaded(true);
            }
            else {
                setInvoiceNoList([]);
                setIsInvoiceNoListLoaded(false);
            }
        } catch (error) {
            throw new Error(`Error fetching invoice numbers: ${error.message}`);
        }
    };

    useEffect(() => {
        if (!isInvoiceNoListLoaded) {
            fetchInvoiceNoList();
        }
    }, [isInvoiceNoListLoaded]);

    const loadInvoiceNoByID = async (selectedIndentNo) => {
        await fetchInvoiceNoList(selectedIndentNo);
    };

    return {
        invoiceNoList,
        setInvoiceNoList,
        loadInvoiceNoByID,
        selectedInvoiceNo,
        setSelectedInvoiceNo,
        selectedInvoiceNoID,
        setSelectedInvoiceNoID
    };
};

export default useIndentInvoiceNoList;
